<script lang="ts">
	import { getGlobalSettings } from "../../getGlobalSettings.js";
	import {
		getStructuredDataScript,
		type StructuredDataSchema,
	} from "../../../../core/schema/utils/getStructuredDataScript.js";
	import voucherImage from "../../../../core/assets/voucher.jpg";
	import { getContext } from "svelte";
	import { pageSlugContextKey } from "../../contexts/pageSlugContextKey.js";
	import { appName } from "../../../../core/schema/names/appName.js";
	import type { VoucherProduct } from "../../../../core/schema/VoucherProduct.js";

	export let voucher: VoucherProduct;

	const { TENANT_LOCALE, WEB_URL } = getGlobalSettings();
	const url = `${WEB_URL}/${getContext<string>(pageSlugContextKey)}`;
	const voucherName = voucher.name[TENANT_LOCALE];
	// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
	function getStructuredDataForProduct() {
		return {
			"@context": "https://schema.org" as const,
			"@type": "Product" as const,
			name: voucherName,
			description: "Dárkový poukaz",
			url,
			image: voucherImage,
			keywords: "poukaz dárek",
			brand: { "@type": "Brand" as const, name: appName },
			offers: {
				"@type": "Offer" as const,
				availability: "https://schema.org/InStock",
				price: voucher.value,
				priceCurrency: "CZK" as const,
				shippingDetails: {
					"@type": "OfferShippingDetails" as const,
					doesNotShip: true as const,
					shippingDestination: {
						"@type": "DefinedRegion" as const,
						addressCountry: "CZ",
					},
				},
				hasMerchantReturnPolicy: {
					"@type": "MerchantReturnPolicy" as const,
					returnPolicyCategory: "https://schema.org/MerchantReturnNotPermitted" as const,
					applicableCountry: "CZ",
				},
			},
		} satisfies StructuredDataSchema;
	}

	const script = getStructuredDataScript(getStructuredDataForProduct());

	/* eslint-disable svelte/no-at-html-tags */
</script>

<svelte:head>
	{@html script}
</svelte:head>
